import { FC } from 'react'
import { BookmarkButtonWrapper } from './styles'
import BookmarkIcon24 from 'shared/assets/24/BookmarkIcon24'
import BookmarkIcon24Fill from 'shared/assets/24/BookmarkIcon24Fill'
import { useBreakpoint } from '@brg/ui'
import { LayoutConst } from 'core'
import BookmarkIcon16Fill from 'shared/assets/16/BookmarkIcon16Fill'
import BookmarkIcon16 from 'shared/assets/16/BookmarkIcon16'
import { useProfile } from '@brg/auth'

interface BookmarkButtonProps {
  isBookmarked?: boolean
  type?: boolean
  onClick?: (e: any) => void
}

export const BookmarkButton: FC<BookmarkButtonProps> = ({onClick, isBookmarked, type}) => {
  const isMobile = useBreakpoint(LayoutConst.screen.sm)
  const isTab = useBreakpoint(LayoutConst.screen.m)
  const profile = useProfile()

  if (!profile) return <></>

  if (isTab) return null;

  return (
    <BookmarkButtonWrapper onClick={onClick} type={type}>
      {
      isBookmarked ? 
        // @ts-ignore
        (isMobile ? <BookmarkIcon16Fill fill='#fff'/> : <BookmarkIcon24Fill fill='#fff'/>) :
        (isMobile ? <BookmarkIcon16 fill='#fff'/> : <BookmarkIcon24 fill='#fff'/>)
      }
    </BookmarkButtonWrapper>
  )
}
import { FC } from 'react'
import { BookmarkButtonWrapper } from './styles'
import BookmarkIcon24 from 'shared/assets/24/BookmarkIcon24'
import BookmarkIcon24Fill from 'shared/assets/24/BookmarkIcon24Fill'
import { useBreakpoint } from '@brg/ui'
import { LayoutConst } from 'core'
import BookmarkIcon16Fill from 'shared/assets/16/BookmarkIcon16Fill'
import BookmarkIcon16 from 'shared/assets/16/BookmarkIcon16'
import { useProfile } from '@brg/auth'

interface BookmarkButtonProps {
  isBookmarked?: boolean
  type?: boolean
  onClick?: (e: any) => void
}

export const BookmarkButton: FC<BookmarkButtonProps> = ({onClick, isBookmarked, type}) => {
  const isMobile = useBreakpoint(LayoutConst.screen.sm)
  const isTab = useBreakpoint(LayoutConst.screen.m)
  const profile = useProfile()

  if (!profile) return <></>

  if (isTab) return null;

  return (
    <BookmarkButtonWrapper onClick={onClick} type={type}>
      {
      isBookmarked ? 
        // @ts-ignore
        (isMobile ? <BookmarkIcon16Fill fill='#fff'/> : <BookmarkIcon24Fill fill='#fff'/>) :
        (isMobile ? <BookmarkIcon16 fill='#fff'/> : <BookmarkIcon24 fill='#fff'/>)
      }
    </BookmarkButtonWrapper>
  )
}
